export default "/_next/static/sounds/trim-page-turn-5-90872ef87926362df23c21f294f1e539.mp3";